/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

const React = require('react');
const { LocaleProvider } = require('./src/i18n/LocaleContext');
const { TranslationProvider } = require('./src/i18n/TranslationContext');
const {
  ElementRenderer,
  DesktopNavigation,
} = require('./src/components/DesktopNavigation');
const { en_lang_keys } = require('./src/i18n/en.js');
const { fr_lang_keys } = require('./src/i18n/fr.js');

exports.wrapPageElement = ({ element, props }) => {
  const splitUri = props.uri.split('/');
  const locale = splitUri[1] && splitUri[1] === 'fr' ? 'fr' : 'en';
  return (
    <LocaleProvider
      locale={{
        locale,
        basePath: props.location.pathname.replace('/fr/', '/'),
        path: props.path,
      }}
    >
      <TranslationProvider
        i18n={{
          en: en_lang_keys,
          fr: fr_lang_keys,
        }}
      >
        <DesktopNavigation />
        <ElementRenderer {...props}>{element}</ElementRenderer>
      </TranslationProvider>
    </LocaleProvider>
  );
};
